"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactSelect = _interopRequireDefault(require("react-select"));
var _async = _interopRequireDefault(require("react-select/async"));
var _i18n = require("@wordpress/i18n");
var _element = require("@wordpress/element");
var _icons = require("@wordpress/icons");
var _useTags2 = require("./hooks/useTags");
var _RefreshButton = _interopRequireDefault(require("./components/RefreshButton"));
var _Error = _interopRequireDefault(require("./components/Error"));
var _customStyles = require("./utils/customStyles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function RegularSelect(_ref) {
  var metaName = _ref.metaName,
    elementID = _ref.elementID,
    existingTags = _ref.existingTags,
    onChange = _ref.onChange,
    refreshButtonClass = _ref.refreshButtonClass,
    _ref$isMulti = _ref.isMulti,
    isMulti = _ref$isMulti === void 0 ? true : _ref$isMulti,
    _ref$isClearable = _ref.isClearable,
    isClearable = _ref$isClearable === void 0 ? null : _ref$isClearable,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$sideIcon = _ref.sideIcon,
    sideIcon = _ref$sideIcon === void 0 ? false : _ref$sideIcon;
  var _useState = (0, _element.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var containerStyles = {
    position: 'relative',
    '&:hover .custom-link-icon': {
      opacity: 0,
      transition: 'opacity 0.1s ease'
    }
  };
  var iconStyles = {
    position: 'absolute',
    right: '45px',
    top: '50%',
    transform: 'translateY(-50%)',
    opacity: isHovered ? 0 : 1,
    transition: 'opacity 0.1s ease',
    zIndex: 1,
    pointerEvents: isHovered ? 'none' : 'auto'
  };
  var _useTags = (0, _useTags2.useTags)(),
    tags = _useTags.tags,
    isLoading = _useTags.isLoading,
    error = _useTags.error,
    isRotating = _useTags.isRotating,
    refreshTags = _useTags.refreshTags,
    isAsync = _useTags.isAsync,
    loadOptions = _useTags.loadOptions;
  var handleChange = function handleChange(value) {
    if (value === null) {
      return onChange(isMulti === 'true' ? [] : {});
    }
    onChange(value);
  };
  if (isAsync) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative'
      },
      onMouseEnter: function onMouseEnter() {
        return setIsHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHovered(false);
      }
    }, /*#__PURE__*/React.createElement(_async["default"], {
      className: "secure-block-inspector__control",
      classNames: {
        multiValue: function multiValue() {
          return 'wpf-media-multi-select-value';
        }
      },
      name: !metaName ? 'wpf-select' : metaName,
      value: existingTags || [],
      placeholder: (0, _i18n.__)('Select tags…', 'wp-fusion-media-tools'),
      onChange: handleChange,
      defaultOptions: tags.slice(0, 1000) || [],
      loadOptions: loadOptions,
      isMulti: isMulti,
      isClearable: isClearable !== null ? isClearable : !isMulti,
      id: elementID,
      isLoading: isLoading,
      isDisabled: isDisabled || isLoading,
      styles: _objectSpread(_objectSpread({}, _customStyles.customSelectStyles), {}, {
        container: function container(base) {
          return _objectSpread(_objectSpread({}, base), containerStyles);
        },
        clearIndicator: function clearIndicator(base) {
          return _objectSpread(_objectSpread({}, base), sideIcon ? {
            opacity: isHovered ? 1 : 0,
            transition: 'opacity 0.1s ease',
            cursor: 'pointer'
          } : {});
        }
      })
    }), sideIcon && !isHovered && /*#__PURE__*/React.createElement("div", {
      className: "custom-link-icon",
      style: iconStyles
    }, /*#__PURE__*/React.createElement(_icons.Icon, {
      icon: sideIcon
    })), !isLoading && /*#__PURE__*/React.createElement(_RefreshButton["default"], {
      isRotating: isRotating,
      refreshTags: refreshTags,
      className: refreshButtonClass
    }), /*#__PURE__*/React.createElement(_Error["default"], {
      error: error
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    },
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    }
  }, /*#__PURE__*/React.createElement(_reactSelect["default"], {
    className: "secure-block-inspector__control",
    classNames: {
      multiValue: function multiValue() {
        return 'wpf-media-multi-select-value';
      }
    },
    name: !metaName ? 'wpf-select' : metaName,
    value: existingTags || [],
    placeholder: (0, _i18n.__)('Select tags…', 'wp-fusion-media-tools'),
    onChange: handleChange,
    options: tags || [],
    isMulti: isMulti,
    isClearable: isClearable !== null ? isClearable : !isMulti,
    id: elementID,
    isLoading: isLoading,
    isDisabled: isDisabled || isLoading,
    styles: _objectSpread(_objectSpread({}, _customStyles.customSelectStyles), {}, {
      container: function container(base) {
        return _objectSpread(_objectSpread({}, base), containerStyles);
      },
      clearIndicator: function clearIndicator(base) {
        return _objectSpread(_objectSpread({}, base), sideIcon ? {
          opacity: isHovered ? 1 : 0,
          transition: 'opacity 0.1s ease',
          cursor: 'pointer'
        } : {});
      }
    })
  }), sideIcon && !isHovered && /*#__PURE__*/React.createElement("div", {
    className: "custom-link-icon",
    style: iconStyles
  }, /*#__PURE__*/React.createElement(_icons.Icon, {
    icon: sideIcon
  })), !isLoading && /*#__PURE__*/React.createElement(_RefreshButton["default"], {
    isRotating: isRotating,
    refreshTags: refreshTags,
    className: refreshButtonClass
  }), /*#__PURE__*/React.createElement(_Error["default"], {
    error: error
  }));
}
var _default = exports["default"] = RegularSelect;